import { ConfirmationType } from "./types";
import { IconName } from "@travelata-libs/ui-kit";

export default function getConfirmationTypeAdditionals(type?: ConfirmationType): { icon: IconName, text: string }[] {
    if (!type) return [];

    const confirmations: Record<ConfirmationType, { icon: IconName, text: string }[]> = {
        [ConfirmationType.Cancel]: [
            { icon: IconName.Discount, text: 'Такие туры часто стоят дешевле аналогов' },
            { icon: IconName.Ban, text: 'Есть риск, что туроператор не подтвердит данный тур' },
            { icon: IconName.ClockExclamation, text: 'Время подтверждения более 72 часов' },
            { icon: IconName.RotateClockwise, text: 'Если тур не подтвердится - предложим замену или вернём деньги' },
        ],
        [ConfirmationType.Long]: [
            { icon: IconName.Discount, text: 'Часто это предложение по лучшей цене' },
            { icon: IconName.Clock, text: 'Туроператор подтверждает тур дольше чем обычно' },
            { icon: IconName.Clock72, text: 'Среднее время подтверждения 72 часа' },
            { icon: IconName.RotateClockwise, text: 'Если тур не подтвердится - предложим замену или вернём деньги' },
        ],
        [ConfirmationType.Quick]: [
            { icon: IconName.ShieldCheck, text: 'Тур с гарантированными местами от туроператора' },
            { icon: IconName.CircleCheck, text: 'Быстро подтверждается' },
            { icon: IconName.PlayerTrackNext, text: 'Раскупают быстрее всего' },
        ],
    }
    return confirmations[type];
}